<template>
	<div class="chart_list">
		<p class="addCross_btn">
			<span class="addCross_btnspan1">
				<span class="textlong " :title="rowText">
					{{$t('DataRecycling.Argument')}}: {{ htmlToString(rowText) }}
				</span>
				<span class="textlong " :title="cloText">
					{{$t('DataRecycling.DependentVariable')}}: {{ htmlToString(cloText) }}
				</span>
			</span>
			<span class="addCross_btnspan2">
				<span>
					<el-select
						@change="function(value){selectionType(value,CrossTabs.id,CrossTabs.crossX,CrossTabs.crossY)}"
						style="width:125px;margin-right:5px" v-model="CrossTabs.chartType" :placeholder="$t('DataRecycling.PleaseSelect')">
						<el-option v-for="item in chartType" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</span>
				<span>
					<el-select style="width:125px ;margin-right:5px" :value="$t('DataRecycling.DisplaySettings')" :placeholder="$t('DataRecycling.PleaseSelect')"
						@change="function(value){ifshow(value,CrossTabs.id,CrossTabs.crossX,CrossTabs.crossY)}">
						<el-option v-for="item in reveal" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</span>
			<!-- 	<span>
					<el-button style="margin-right:5px" @click="exportingleCrossAnalysis(CrossTabs.id)">导出</el-button>
				</span> -->
				<span @click="delchart(CrossTabs.id,CrossTabsindex)"><i
						class="icon wjpc-iconfont wjpc-icon-shanchu"></i></span>
			</span>
		</p>
		<div v-show="chartdataState" class="echart" ref="echart_div"
			:style="{ width: '60%', height: '400px',margin: '0px auto' }"></div>

		<table v-show="dataTableState" border="1" class="chartLineTable">
			<tr class="table_tr">
				<td class="table_td" v-for="(item, index) in tableDataOne" :key="index + 'item'">{{ htmlToString(item) }}</td>
				<td class="table_td">{{$t('DataRecycling.TotalNumberOfInterviewees')}}</td>
			</tr>

			<tr v-for="(itemrow, index2) in oneArray" :key="index2" class="table_tr">
				<td class="table_td">
					{{ htmlToString(itemrow[0].name) }}
					<div class="divider"></div>
					<div>{{  htmlToString(itemrow[0].name) }}_{{$t('DataRecycling.RowPercentage')}}</div>
				</td>

				<td v-for="(itemcol, index3) in itemrow" :key="index3" class="table_td">
					{{ itemcol.people }}
					<div class="divider"></div>
					{{ ((itemcol.people / itemcol.rowpeoplecount) * 100) ||0 | toFixed(1) }}%
				</td>
				<td class="table_td">
					<span>
					{{ itemrow[0].rowpeoplecount }}
					</span>
					<div class="divider"></div>
					<div > &ensp;</div>
				</td>
			</tr>

			<tr class="table_tr">
				<td class="table_td">{{$t('DataRecycling.TotalNumberOfInterviewees')}}</td>
				<td v-for="(item3, index3) in oneArray[0]" :key="index3" class="table_td">{{ item3.colpeoplecount }}
				</td>
				<td class="table_td"></td>
			</tr>
		</table>
	</div>
</template>

<script>
	import echarts from 'echarts';

	export default {
		props: {
			CrossTabs: {
				type: Object //可指定接收类型，如:Array.
			},
			CrossTabsindex: {

			}
		},
		data() {
			return {
				chartState: 1,
				TableState: 1,
				chartdataState: true, //图表状态
				dataTableState: true, //数据表状态
				rowText: '', //行
				cloText: '', //列
				NewCrossTabs: {},
				oneArray: [], // 二维数组
				legend: {
					data: []
				},
				indicator: [],
				leidaData: [],
				type: 1,
				tableDataOne: [],
				reveal: [{
						label: this.$t('DataRecycling.HideChart'),
						value: 0
					},
					{
						label: this.$t('DataRecycling.HideTable'),
						value: 1
					}
				],

				chartType: [{
						label: this.$t('DataRecycling.RadarChart'),
						value: 8
					},
					{
						label: this.$t('DataRecycling.StackedBarChart'),
						value: 7
					},
					{
						label: this.$t('DataRecycling.StackedColumnChart'),
						value: 6
					}
				],
				setchartType: 6,
				value: this.$t('DataRecycling.ChartType')
			};
		},
		mounted() {
			this.queryCrossAnalyzeDetails(this.CrossTabs.id);
			this.wid = sessionStorage.getItem('wid') || 0;
		},
		methods: {
			htmlToString(htmlStr){
				return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g,'')
			},
			exportingleCrossAnalysis(id) {
				// console.log(id);
				window.open(this.$config.service.exportingleCrossAnalysis + '?id=' + id + '&Authorization=' + 'Bearer ' +
					window.localStorage.getItem('token') + '&type=' + '0');
			},
			ifshow(value, id, x, y) {
				// let chartState = 1;
				// let dataTableState = 1;
				if (value == 0) {
					this.chartdataState = false
					this.reveal[0].label = this.$t('DataRecycling.DisplayChart')
					this.reveal[0].value = 3
					this.chartState = 0
				}
				if (value == 3) {
					this.chartdataState = true
					this.reveal[0].label = this.$t('DataRecycling.HideChart')
					this.reveal[0].value = 0
					this.chartState = 1
				}
				if (value == 1) {
					this.dataTableState = false
					this.reveal[1].label = this.$t('DataRecycling.DisplayTable')
					this.reveal[1].value = 4
					this.TableState = 0
				}
				if (value == 4) {
					this.dataTableState = true
					this.reveal[1].label = this.$t('DataRecycling.HideTable')
					this.reveal[1].value = 1
					this.TableState = 1
				}

				let params = {
					that: this,
					url: `${this.$config.service.setChartType}`,
					method: 'POST',
					data: {
						id: id,
						crossx: x,
						crossy: y,
						chartType: this.setchartType,
						chartState: this.chartState,
						dataTableState: this.TableState
					},
					cb(res) {
						if (res.code == 0) {}
					}
				};
				this.$util.request(params);
			},
			//查询已有交叉分析的数据详情
			queryCrossAnalyzeDetails(id) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.queryCrossAnalyzeDetails}?id=${id}`,
					method: 'GET',
					data: {},
					cb(res) {
						if (res.code == 0) {
							that.initChart(res.resultBody.crossAnalyseVOList);
							that.rowText = res.resultBody.crossXName
							that.cloText = res.resultBody.crossYName
						}
					}
				};
				this.$util.request(params);
			},
			initChart(NewCrossTabs) {
				let oneArray = new Array();
				let towArray = new Array();
				let lastflat = '';
				for (let i = 0; i < NewCrossTabs.length; i++) {
					let rowflag = NewCrossTabs[i].rownum;
					if (lastflat != '' && lastflat != rowflag) {
						//一位数组计算完成
						oneArray.push(towArray);
						towArray = new Array();
					}
					towArray.push(NewCrossTabs[i]);
					lastflat = rowflag;
				}
				if (towArray != null && towArray.length > 0) {
					oneArray.push(towArray);
					towArray = new Array();
				}
				console.log(oneArray)
				this.oneArray = oneArray;
				if (this.CrossTabs.chartType == 6) {
					this.cumulate();
				}
				if (this.CrossTabs.chartType == 7) {
					this.cumulate2();
				}
				if (this.CrossTabs.chartType == 8) {
					this.radar(); //雷达
				}

				let tempColName = [];
				tempColName.push(' ');
				oneArray[0].forEach((itemcol, index1) => {
					tempColName.push(itemcol.type);
				});
				this.tableDataOne = tempColName;


			},

			//切换图表类型
			selectionType(value, id, x, y) {
				this.legend.data = [];
				this.indicator = [];
				this.leidaData = [];
				if (value == 8) {
					this.radar();
					this.setchartType = 8
				}
				if (value == 6) {
					this.cumulate();
					this.setchartType = 6
				}
				if (value == 7) {
					this.cumulate2();
					this.setchartType = 7
				}
				this.ifshow(6, id, x, y)
			},
			// 雷达图
			radar() {
				let oneArray = this.oneArray;
				let seriesList = {}; //系列数据
				seriesList.data = [];
				seriesList.type = 'radar';

				for (let i = 0; i < oneArray.length; i++) {
					let temporarydata = {}
					temporarydata.value = [];
					temporarydata.name = '';
					let categoryType = []; //x轴数据
					let legendData = ''
					for (let l = 0; l < oneArray[i].length; l++) {
						let temporaryName = ''
						temporaryName = this.htmlToString(oneArray[i][l].name)
						if (!temporaryName) return '';
						if (temporaryName.length > 5) {
							temporaryName = temporaryName.slice(0, 10) + '...';
						}
						temporarydata.name = temporaryName
						temporarydata.value.push((oneArray[i][l].people / oneArray[i][l].rowpeoplecount * 100).toFixed(2))
						let temporaryTypeName = ''
						temporaryTypeName = this.htmlToString(oneArray[i][l].type)
						if (!temporaryTypeName) return '';
						if (temporaryTypeName.length > 5) {
							temporaryTypeName = temporaryTypeName.slice(0, 5) + '...';
						}
						categoryType.push({
							name: temporaryTypeName
						})
						legendData = temporaryName
					};
					seriesList.data.push(temporarydata)
					this.legend.data.push(legendData)
					this.indicator = categoryType;
				}
				this.leidaData.push(seriesList)
				let getchart = echarts.init(this.$refs.echart_div);
				let option = {
					title: {
						// text: '基础雷达图'
					},
					color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
					tooltip: {},
					legend: this.legend,
					// tooltip: {
					//     trigger: 'axis',
					//     formatter: '{a0}: {c0}%   <br/>{a1}: {c1}%  <br />{a2}: {c2}%  <br />{a3}: {c3}%'  // 显示百分比
					// },
					radar: {
						// shape: 'circle',
						name: {
							textStyle: {
								color: '#fff',
								backgroundColor: '#999',
								borderRadius: 3,
								padding: [3, 5]
							}
						},
						indicator: this.indicator
					},
					series: this.leidaData
				};
				getchart.clear();
				getchart.setOption(option);
				//随着屏幕大小调节图表
				window.addEventListener('resize', () => {
					getchart.resize();
				});
			},
			// 堆叠柱状图
			cumulate() {
				let oneArray = this.oneArray;
				let targetArr = [];
				oneArray.forEach((val, index) => {
					val.forEach((v, i) => {
						if (targetArr[i]) {
							targetArr[i].push(v)
						} else {
							targetArr[i] = [v];
						}
					});
				})
				for (let i = 0; i < targetArr.length; i++) {
					let seriesList = {}; //系列数据
					seriesList.name = '';
					seriesList.type = 'bar',
						seriesList.stack = 'total';
					seriesList.label = {
							show: true
						},
						seriesList.emphasis = {
							focus: 'series'
						},
						seriesList.data = [];
					let categoryType = []; //x轴数据
					for (let l = 0; l < targetArr[i].length; l++) {
						let temporarytargetArr = ''
						temporarytargetArr = this.htmlToString(targetArr[i][l].type)
						if (!temporarytargetArr) return '';
						if (temporarytargetArr.length > 5) {
							temporarytargetArr = temporarytargetArr.slice(0, 5) + '...';
						}
						seriesList.name = temporarytargetArr
						seriesList.data.push((targetArr[i][l].people / targetArr[i][l].rowpeoplecount * 100).toFixed(2))
						let temporaryName = ''
						temporaryName = this.htmlToString(targetArr[i][l].name)
						if (!temporaryName) return '';
						if (temporaryName.length > 5) {
							temporaryName = temporaryName.slice(0, 10) + '...';
						}
						categoryType.push(temporaryName)
						this.legend.data.push(temporarytargetArr)
					};
					this.leidaData.push(seriesList)
					this.indicator = categoryType;
				}
				console.log(this.leidaData)
				let getchart = echarts.init(this.$refs.echart_div);
				let option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							// 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: this.legend,
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						// formatter: '{a0}: {c0}%   <br/>{a1}: {c1}%  <br />{a2}: {c2}%  <br />{a3}: {c3}%'  // 显示百分比
					},
					color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
					xAxis: [{
						type: 'category',
						data: this.indicator
					}],
					yAxis: [{
						axisLabel: {
							// 显示百分比
							show: true,
							interval: 'auto',
							formatter: '{value} %'
						},
						type: 'value'
					}],
					series: this.leidaData
				};
				getchart.clear();
				getchart.setOption(option);
				//随着屏幕大小调节图表
				window.addEventListener('resize', () => {
					getchart.resize();
				});
			},
			// 堆叠条状图
			cumulate2() {
				let oneArray = this.oneArray;
				let targetArr = [];
				oneArray.forEach((val, index) => {
					val.forEach((v, i) => {
						if (targetArr[i]) {
							targetArr[i].push(v)
						} else {
							targetArr[i] = [v];
						}
					});
				})
				for (let i = 0; i < targetArr.length; i++) {
					let seriesList = {}; //系列数据
					seriesList.name = '';
					seriesList.type = 'bar',
						seriesList.stack = 'total';
					seriesList.label = {
							show: true
						},
						seriesList.emphasis = {
							focus: 'series'
						},
						seriesList.data = [];
					let categoryType = []; //x轴数据
					for (let l = 0; l < targetArr[i].length; l++) {
						let temporarytargetArr = ''
						temporarytargetArr = this.htmlToString(targetArr[i][l].type)
						if (!temporarytargetArr) return '';
						if (temporarytargetArr.length > 5) {
							temporarytargetArr = temporarytargetArr.slice(0, 5) + '...';
						}
						seriesList.name = temporarytargetArr
						seriesList.data.push((targetArr[i][l].people / targetArr[i][l].rowpeoplecount * 100).toFixed(2))
						let temporaryName = ''
						temporaryName = this.htmlToString(targetArr[i][l].name)
						if (!temporaryName) return '';
						if (temporaryName.length > 5) {
							temporaryName = temporaryName.slice(0, 10) + '...';
						}
						categoryType.push(temporaryName)
						this.legend.data.push(temporarytargetArr)
					};
					this.leidaData.push(seriesList)
					this.indicator = categoryType;
				}
				let getchart = echarts.init(this.$refs.echart_div);
				let option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							// 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: this.legend,
					tooltip: {
						trigger: 'axis',
						// formatter: '{a0}: {c0}%   <br/>{a1}: {c1}%  <br />{a2}: {c2}%  <br />{a3}: {c3}%'  // 显示百分比
					},
					color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'value'
					}],
					yAxis: [{
						type: 'category',
						data: this.indicator
					}],
					series: this.leidaData
				};
				getchart.clear();
				getchart.setOption(option);
				//随着屏幕大小调节图表
				window.addEventListener('resize', () => {
					getchart.resize();
				});
			},
			//删除
			delchart(id, index) {
				this.$emit("delchart", id, index)
			}

		}
	};
</script>
<style lang="scss" scoped="scoped">
	.chart_list {
		padding: 0 30px;
		padding-bottom: 5px;
		overflow: auto;
		border-top: 1px solid #eaeaea;
		background-color: #fff;
		box-sizing: border-box;

		.addCross_btn {
			margin-bottom: 10px;
			background-color: #fafafa;
			padding: 5px 10px;
			height: 50px;
			line-height:50px;
			display: flex;
			justify-content: space-between;
		}

		.echar {
			margin-top: 30px;
		}
	}

	.chartLineTable {
		width: 60%;
		margin: 0 auto;
		border: 1px solid #dbdada;
		margin-bottom: 20px;
		border-collapse: collapse;
		border-spacing: 0;
		margin-top: 20px;

		// padding: 5px;
		.table_tr {
			.table_td {
				padding: 8px;
				.divider {
					background-color: #dcdfe6;
					position: relative;
					display: block;
					height: 1px;
					width: 106%;
					margin: 5px -4px 5px -4px;
				}
			}
		}

		.table_tr:first-child(td) {
			background-color: #f9fcff;
		}
	}
</style>
